import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiImage,FiVideo,FiPlus,FiTrash2}=FiIcons;

function normalizeMedia(color) {
  if (Array.isArray(color.media) && color.media.length > 0) {
    return color.media;
  }
  if (color.image_url) {
    return [
      {
        id: `legacy-${color.id || crypto.randomUUID()}`,
        media_url: color.image_url,
        media_type: 'image',
        sort_order: 0
      }
    ];
  }
  return [];
}

function ColorMediaEditor({color,onChange}) {
  const media=normalizeMedia(color);

  const commit=(nextMedia)=> {
    const normalized=nextMedia.map((item,index)=> ({
      ...item,
      sort_order: index,
      is_primary: index===0
    }));
    onChange({
      ...color,
      media: normalized,
      image_url: normalized[0]?.media_url || ''
    });
  };

  const updateField=(index,field,value)=> {
    commit(
      media.map((item,itemIndex)=>
        itemIndex===index ? {...item,[field]: value} : item
      )
    );
  };

  const addPhoto=()=> {
    commit([
      ...media,
      {
        id: `temp-media-${crypto.randomUUID()}`,
        media_url: '',
        media_type: 'image',
        sort_order: media.length
      }
    ]);
  };

  const removePhoto=(index)=> {
    commit(media.filter((_,itemIndex)=> itemIndex !==index));
  };

  return (
    <div className="color-photo-fields">
      <div className="color-photo-heading">
        <span>
          <SafeIcon icon={FiImage} />
          Photos &amp; Videos for {color.name || 'this color'}
        </span>
        <button
          type="button"
          className="admin-btn-secondary small"
          onClick={addPhoto}
        >
          <SafeIcon icon={FiPlus} />
          Add photo / video
        </button>
      </div>

      {media.map((item,index)=> (
        <div className="color-photo-row" key={item.id || index}>
          <div className="color-field color-field-position">
            <span className="color-field-label">Position</span>
            <span className="color-photo-label">
              {index===0 ? 'Primary' : `#${index + 1}`}
            </span>
          </div>
          <div className="color-field color-field-type">
            <span className="color-field-label">Media Type</span>
            <select
              className="color-media-type-select"
              value={item.media_type || 'image'}
              onChange={(e)=>
                updateField(index,'media_type',e.target.value)
              }
              aria-label={`Media type for ${color.name || 'color'} item ${index + 1}`}
            >
              <option value="image">Photo</option>
              <option value="video">Video</option>
            </select>
          </div>
          <div className="color-field">
            <span className="color-field-label">
              {item.media_type==='video' ? 'Video URL' : 'Image URL'}
            </span>
            <input
              type="url"
              value={item.media_url || ''}
              placeholder={
                item.media_type==='video'
                  ? 'https://example.com/video.mp4'
                  : 'https://example.com/photo.jpg'
              }
              aria-label={`${color.name || 'Color'} ${item.media_type==='video' ? 'video' : 'photo'} ${index + 1} URL`}
              onChange={(e)=>
                updateField(index,'media_url',e.target.value)
              }
            />
          </div>
          <button
            type="button"
            className="color-photo-remove"
            onClick={()=> removePhoto(index)}
            aria-label={`Remove item ${index + 1}`}
          >
            <SafeIcon icon={FiTrash2} />
          </button>
        </div>
      ))}

      {media.length===0 && (
        <button
          type="button"
          className="color-photo-empty"
          onClick={addPhoto}
        >
          <SafeIcon icon={FiPlus} />
          Add the first photo or video for this color
        </button>
      )}
    </div>
  );
}

export default ColorMediaEditor;